import React from "react";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { StyledFormElementsWrapper, ContainerGrid, FormLabel } from "../styles";
import { CustomFileUpload } from "../../../common/FormInputs";
import FormField from "../../../common/FormField/FormField";
import CustomSelect from "./CustomSelect";
import styled from "styled-components";
import theme from "../../../../assets/theme";
import COLORS from "../../../../assets/Colors";

const UpdateNotice = ({
  values,
  handleChange,
  errors,
  touched,
  handleBlur,
  setFieldValue,
  s3Upload,
  getFileName,
  menuItems,
  getNoticeTemplates,
  menuNotice,
  menuTemplateCode,
  openTemplatePreview,
  onTemplateFilePicked,
  onEditTemplate,
}) => {
  const selectedTemplate = menuTemplateCode[values?.noticeCategory]?.find(
    (template) => template?.templateCode === values?.templateCode,
  );

  
  const editSourceUrl =
    values?.noticeTemplate || selectedTemplate?.noticeTemplate || "";

 
  const clearPickedTemplate = () => {
    setFieldValue("noticeTemplate", "");
    if (onTemplateFilePicked) onTemplateFilePicked("noticeTemplate", null);
  };

  const handleCategoryChange = (event) => {
    setFieldValue("noticeCategory", event.target.value);
    setFieldValue("templateCode", "");
    clearPickedTemplate();
  };

  const handleTemplateChange = (event) => {
    const template = menuTemplateCode[values?.noticeCategory]?.find(
      (item) => String(item?.id) === String(event.target.value),
    );
    setFieldValue("templateCode", template?.templateCode || "");
    clearPickedTemplate();
    openTemplatePreview(template);
  };

  const inputs = [
    {
      type: "select",
      name: "noticeCategory",
      label: "Notice Category",
      required: true,
      items: menuNotice,
      onChange: handleCategoryChange,
    },
    {
      type: "select",
      name: "templateCode",
      label: "Template Code",
      required: true,
      value: selectedTemplate?.id || "",
      onChange: handleTemplateChange,
      previewUrl: selectedTemplate?.noticeTemplate,
      onPreview: () => openTemplatePreview(selectedTemplate),
      items: menuTemplateCode[values?.noticeCategory]?.length
        ? menuTemplateCode[values?.noticeCategory]?.map(
            ({ id, templateCode, historyDisplay }) => ({
              id,
              label: templateCode,
              value: id,
              historyDisplay,
            }),
          )
        : [],
    },
  ];

  const upload_templates = [
    {
      name: "noticeTemplate",
      label: "Upload Notice Template (docx)",
      type: "upload",
      required: true,
      accept: ".docx",
      types: [
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ],
    },
    {
      name: "excelTemplate",
      label: "Upload Excel Template (xlsx)",
      type: "upload",
      required: true,
      accept: ".xlsx",
      types: [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
        "text/csv",
      ],
    },
  ];

  return (
    <>
      <StyledFormElementsWrapper style={{ marginBottom: 8, marginTop: 15 }}>
        <SectionTitle>
          <SectionIcon>{"✏️"}</SectionIcon>
          Update Notice Template
        </SectionTitle>

        <ContainerGrid className="disabledArrows">
          <CustomSelect
            name="partyId"
            trigger={true}
            value={values["partyId"]}
            {...{
              errors,
              touched,
              setFieldValue,
              menuItems,
              getNoticeTemplates,
            }}
          />
          {inputs.map((input) => (
            <div key={input.name}>
              <FormField
                menuItems={input.items}
                {...{
                  touched,
                  errors,
                  input,
                  values,
                  handleChange,
                  handleBlur,
                  setFieldValue,
                }}
              />
              {input.name === "templateCode" &&
              onEditTemplate &&
              values?.templateCode &&
              editSourceUrl ? (
                <EditTemplateRow>
                  <EditTemplateButton
                    type="button"
                    onClick={() =>
                      onEditTemplate("noticeTemplate", editSourceUrl)
                    }
                    title="Open this template code's document in the Notice Editor"
                  >
                    <EditOutlinedIcon style={{ fontSize: 16 }} />
                    Edit
                  </EditTemplateButton>
                  <EditTemplateHint>
                    Edit the template document and save to upload it as the new
                    notice template
                  </EditTemplateHint>
                </EditTemplateRow>
              ) : null}
            </div>
          ))}
          {upload_templates.map((upload, index) => (
            <UploadBlock key={index}>
              <FormLabel>
                {upload.label}
                <span className="required-star"> *</span>
              </FormLabel>
              <CustomFileUpload
                error={touched[upload.name] && errors[upload.name]}
                setFile={(file) => {
                  if (onTemplateFilePicked) {
                    onTemplateFilePicked(upload.name, file);
                  }
                  s3Upload(file, upload.name, setFieldValue, upload.types);
                }}
                style={{ width: "100%" }}
                accept={upload.accept}
                file={{ name: getFileName(values[upload.name]) }}
              />
            </UploadBlock>
          ))}
        </ContainerGrid>
      </StyledFormElementsWrapper>
    </>
  );
};

export default UpdateNotice;

const SectionTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 16px;
  font-weight: 700;
  color: ${COLORS.COLOR_DARK};
  margin-bottom: 24px;
  padding-bottom: 14px;
  border-bottom: 1.5px solid rgba(0, 131, 140, 0.1);
`;

const SectionIcon = styled.span`
  width: 32px;
  height: 32px;
  background: linear-gradient(
    135deg,
    rgba(0, 131, 140, 0.12),
    rgba(105, 227, 194, 0.15)
  );
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
`;

const UploadBlock = styled.div`
  margin-top: 10px;
`;

const EditTemplateRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
  flex-wrap: wrap;
`;

const EditTemplateButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border: 1px solid ${COLORS.BTN_GREEN};
  border-radius: 6px;
  background: rgba(0, 131, 140, 0.08);
  color: ${COLORS.BTN_GREEN};
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(0, 131, 140, 0.16);
  }
`;

const EditTemplateHint = styled.span`
  font-family: ${theme.fonts.primaryFontRegular};
  font-size: 12px;
  color: ${COLORS.INPUT_LABEL};
`;
